import { useState } from "react"
import styled from "styled-components"

export const Slider = ({
    title,
    values,
    defaultValue,
    onChange,
    onChangeEnd
}) => {

    const [sliderValue, setSliderValue] = useState(() => {
        if (!values?.length) return 0;
        const idx = values.findIndex(
            el => el.value === defaultValue
        );

        if (idx === -1) return 0;
        return (idx / (values.length - 1)) * 100;
    });

    const selectedIndex = Math.round((values.length - 1) * (sliderValue / 100));

    const selectedValue = values[selectedIndex];

    const changeFunction = (e) => {
        const val = Number(e.target.value);
        setSliderValue(val);
        onChange?.(selectedValue.value);
    };

    const changeEndFunction = () => {
        onChangeEnd?.(selectedValue.value);
    };

    const offset = (0.5 - (sliderValue / 100)) * 15;

    return (
        <StyledSlider>

            {title ? <span className="sliderTitle">{title}</span> : null}

            <input
                type="range"
                min={0}
                max={100}
                value={sliderValue}
                onChange={changeFunction}
                onPointerUp={changeEndFunction}
            />

            <div
                className="sliderValueTooltip"
                style={{
                    left: `calc(${sliderValue}% + ${offset}px)`
                }}
            >
                {selectedValue?.name}
            </div>

        </StyledSlider>
    );
};

const StyledSlider = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({theme}) => theme.spacing.sm};
    position: relative;

    span.sliderTitle
    {
        font-size: ${({theme}) => theme.fontSize.md};
        font-weight: 500;
        color: ${({theme}) => theme.colors.neutralPrimaryForeground};
        font-size: ${({theme}) => theme.fontSize.sm};
        padding-left: ${({theme}) => theme.spacing.md};
    }

    input[type='range']
    {
        margin-top: ${({theme}) => theme.spacing.md};
        margin-bottom: ${({theme}) => theme.spacing.lg};
        -webkit-appearance: none;
        appearance: none;
        width: 100%;
        height: 5px;
        background: ${({theme}) => theme.colors.neutralPrimaryBorder};
        border-radius: ${({theme}) => theme.cornerRadius.sm};

        &::-webkit-slider-thumb
        {
            -webkit-appearance: none;
            appearance: none;
            width: 15px;
            height: 15px;
            border-radius: ${({theme}) => theme.cornerRadius.sm};
            background: ${({theme}) => theme.colors.accentForeground};
            cursor: pointer;
        }
    }

    div.sliderValueTooltip
    {
        font-size: ${({theme}) => theme.fontSize.sm};
        font-weight: 600;
        position: absolute;
        top: 45px;
        text-align: center;
        transform: translateX(-50%);
    }
`